// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Types
import { MeasurementType } from '../../../../../../types/global';

// Components
import {
  LineChart,
  LineChartType,
  SeriesColorEnum,
} from '../../../../../../layout/elements/LineChart';

// View
import { PIDProps } from './PID.types';
import { ChartMode } from '../Trendings.types';

function PID({
  className,
  chartMode,
  testId,
  trendingPIDData,
}: PIDProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  // Generate dynamic ID based on chart mode
  const chartId: string = `pid-${chartMode}`;

  return (
    <LineChart
      activeBullet={chartMode === ChartMode.live || chartMode === ChartMode.liveAggregate}
      className={className}
      data={trendingPIDData}
      id={chartId}
      series={[
        {
          name: t('common.cloudConnection'),
          field: 'edgeStatus',
          type: LineChartType.fill,
          date: 'timestamp',
          opposite: true,
          measurementType: MeasurementType.temperature,
        },
        {
          name: t('view.crusher.trendings.pid.legend.currentCrusherAmps'),
          field: 'crusherMotorAmps',
          type: LineChartType.line,
          date: 'timestamp',
          unit: 'A',
          decimals: 2,
          color: SeriesColorEnum.green,
          bullet: true,
          minScale: 0,
          maxScale: 750,
        },
        {
          name: t('view.crusher.trendings.pid.legend.currenCavityLevel'),
          field: 'cavityLevel',
          type: LineChartType.line,
          date: 'timestamp',
          unit: '%',
          opposite: true,
          decimals: 2,
          color: SeriesColorEnum.blue,
          bullet: true,
          minScale: 0,
          maxScale: 100,
        },
        // { // @@TODO: apply the dynamic value after first release
        //   name: t('view.crusher.trendings.pid.legend.currentCrusherSP'),
        //   field: 'currentCrusherSP',
        //   type: LineChartType.line,
        //   date: 'timestamp',
        //   unit: 'A',
        //   color: 'yellow',
        //   bullet: true,
        // },
        // { // @@TODO: apply the dynamic after first release
        //   name: t('view.crusher.trendings.pid.legend.cavityLevelSP'),
        //   field: 'cavityLevelSP',
        //   type: LineChartType.line,
        //   date: 'timestamp',
        //   unit: '%',
        //   opposite: true,
        //   color: 'orange',
        //   bullet: true,
        // },
        // {
        //   name: t('view.crusher.trendings.pid.legend.feedSpeed'),
        //   field: 'feedSpeed',
        //   type: LineChartType.line,
        //   date: 'timestamp',
        //   unit: '%',
        //   opposite: true,
        //   color: 'green',
        //   bullet: true,
        // },
      ]}
      testId={testId}
    />
  );
}

export { PID };
